import { useBankingSignupModal } from 'hooks/Bank/useBankingSignupModal';
import type { FC, ReactNode } from 'react';
import { BankingSignupModalContext } from './BankingSignupModalContext';

const BankingSignupModalProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { modalContent, openSignupFlow } = useBankingSignupModal();

  return (
    <BankingSignupModalContext.Provider value={openSignupFlow}>
      {children}
      {modalContent}
    </BankingSignupModalContext.Provider>
  );
};

export default BankingSignupModalProvider;
